import Layout from "../Layout";
import Loader from "../Layout/loader";
import { useEffect, useState } from "react";

import { FaPlus } from "react-icons/fa6";
import { FaPencilAlt, FaTrash } from "react-icons/fa";

import { cores, itemsList } from "../Layout/constants";

import axios from "axios";
import CryptoJS from "crypto-js";

import { codigoParaImagem, codigoEvento } from "../Utils/utils";

function Grupos() {
  useEffect(() => {
    refreshGrupos();
  }, []);
  function refreshGrupos() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Grupo`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setGrupos(res.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function criar() {
    let imgAux = imagem.match(/\/(\d+)\.png$/);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Grupo`,
        {
          descricao: descricao,
          imagem: codigoParaImagem(imagem),
          cor: buscaCor,
          codaluguel: codigoEvento(),
        },
        {
          headers: {
            auth: process.env.REACT_APP_API_TOKEN,
            "Content-Type": "application/json",
          },
        }
      )
      .then((retorno) => {
        window.location.reload(true);
      });
  }

  function atualizar() {
    axios
      .put(
        `${process.env.REACT_APP_API_URL}/Grupo`,
        {
          codigo: codigo,
          descricao: descricao,
          imagem: codigoParaImagem(imagem),
          cor: buscaCor,
          codaluguel: codigoEvento(),
        },
        {
          headers: {
            auth: process.env.REACT_APP_API_TOKEN,
            "Content-Type": "application/json",
          },
        }
      )
      .then((retorno) => {
        window.location.reload(true);
      });
  }

  function excluir(codGrupo) {
    axios
      .delete(`${process.env.REACT_APP_API_URL}/Grupo`, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
        params: {
          codGrupo: codGrupo,
          codaluguel: codigoEvento(),
        },
      })
      .then((retorno) => {
        window.location.reload(true);
      });
  }
  const [isLoading, setIsLoading] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalData, setModalData] = useState({});

  const [buscaItem, setBuscaItem] = useState("");
  const [buscaCor, setBuscaCor] = useState("");
  const [aberto, setAberto] = useState(false);
  const [aberto2, setAberto2] = useState(false);

  const [selecionado, setSelecionado] = useState(null);
  const [codigo, setCodigo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [imagem, setImagem] = useState("");
  const [cor, setCor] = useState("");

  const [grupos, setGrupos] = useState([]);

  const filtrados = grupos.filter((grupo) => {
    return (
      grupo.DESCRICAO.toLowerCase().includes(filtro.toLowerCase()) ||
      grupo.CODIGO.toString().includes(filtro)
    );
  });

  const itensFiltrados = itemsList.filter((item) => {
    return item.label.toLowerCase().includes(buscaItem.toLowerCase());
  });

  const coresFiltradas = cores.filter((item) => {
    return item.label.toLowerCase().includes(buscaCor.toLowerCase());
  });

  function convertAPIColor(argb) {
    const hex = argb.replace("$", "");
    const blue = hex.substring(2, 4);
    const green = hex.substring(4, 6);
    const red = hex.substring(6, 8);
    return `#${red}${green}${blue}`;
  }

  const handleSelecionar = (option) => {
    setSelecionado(option);
    setBuscaItem(option.label);
    setAberto(false);
  };

  return (
    <Layout>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="font-Roboto flex box-border p-2 lg:p-12 flex-col gap-4 justify-center items-center w-full">
            {openModal ? (
              <div className="fixed inset-0 z-10 flex items-center justify-center">
                <div
                  onClick={() => {
                    setOpenModal(false);
                    setModalType("");
                    setModalData({});
                  }}
                  className="absolute h-screen inset-0 bg-black/60 backdrop-blur-sm"
                ></div>
                <div className="relative z-20 bg-white rounded-lg w-[90%] lg:w-[70%] max-h-[80vh] overflow-hidden flex flex-col">
                  <div className="overflow-y-auto p-4 flex-1">
                    {modalType === "create" ? (
                      <div className="flex flex-col box-border p-4 gap-2 w-full">
                        <h1 className="font-Oswald text-center">Novo Grupo</h1>
                        <div className="flex overflow-hidden justify-center items-center flex-col box-border p-4 gap-2 w-full">
                          <div
                            style={{
                              backgroundColor: cor,
                            }}
                            className={`flex max-w-[90%] items-center gap-4 p-2 rounded-lg text-white w-fit`}
                          >
                            <img width={"70px"} src={`${imagem}`} alt="Grupo" />
                            <span className="text-center">{descricao}</span>
                          </div>
                        </div>

                        <form className="flex items-center flex-wrap gap-2 w-full">
                          <div className="flex flex-col gap-2 text-base font-[500]">
                            <label htmlFor="codigo">Descrição</label>
                            <input
                              name="codigo"
                              type="text"
                              onChange={(e) => setDescricao(e.target.value)}
                              className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              value={descricao}
                              placeholder="Descrição"
                              required
                            />
                          </div>
                          <div className="font-Roboto flex flex-col gap-2 w-fit">
                            <label
                              className="font-Roboto text-base font-[500] w-fit"
                              htmlFor="select"
                            >
                              Imagem
                            </label>
                            <div className="font-Roboto font-[500] relative">
                              <input
                                autoComplete="off"
                                type="text"
                                name="select"
                                className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Selecione uma opção"
                                value={buscaItem}
                                onChange={(e) => {
                                  setBuscaItem(e.target.value);
                                  // setAberto(!aberto);
                                }}
                                onFocus={() => {
                                  setBuscaItem("");
                                  setAberto(!aberto);
                                }}
                                required
                              />

                              {aberto && (
                                <ul className="font-Roboto text-base font-[500] absolute z-10 w-full bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                                  {itensFiltrados.length > 0 ? (
                                    itensFiltrados.map((option) => (
                                      <li
                                        key={option.value}
                                        className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                        onClick={() => {
                                          setImagem(option.value);
                                          setAberto(false);
                                          setBuscaItem(option.label);
                                        }}
                                      >
                                        <div className="flex gap-4">
                                          <img
                                            src={`${option.value}`}
                                            alt="Grupo"
                                            width={"50px"}
                                          />
                                          <span>{option.label}</span>
                                        </div>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="font-Roboto px-4 py-2 text-gray-500">
                                      Nenhuma opção encontrada
                                    </li>
                                  )}
                                </ul>
                              )}
                            </div>
                          </div>

                          <div className="font-Roboto flex flex-col gap-2 w-fit">
                            <label
                              className="font-Roboto text-base font-[500] w-fit"
                              htmlFor="select"
                            >
                              Cor
                            </label>
                            <div className="font-Roboto font-[500] relative">
                              <input
                                autoComplete="off"
                                type="text"
                                name="select"
                                style={{ backgroundColor: cor }}
                                className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Selecione uma opção"
                                value={buscaCor}
                                onChange={(e) => {
                                  setBuscaCor(e.target.value);
                                  // setAberto2(!aberto2);
                                }}
                                onFocus={() => {
                                  setBuscaCor("");
                                  setAberto2(!aberto2);
                                }}
                                required
                              />

                              {aberto2 && (
                                <ul className="font-Roboto text-base font-[500] absolute z-10 w-full bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                                  {coresFiltradas.length > 0 ? (
                                    coresFiltradas.map((option) => (
                                      <li
                                        key={option.value}
                                        style={{
                                          backgroundColor: option.value,
                                        }}
                                        className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                        onClick={() => {
                                          setCor(option.value);
                                          setAberto2(false);
                                          setBuscaCor(option.label);
                                        }}
                                      >
                                        <span>{option.label}</span>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="font-Roboto px-4 py-2 text-gray-500">
                                      Nenhuma opção encontrada
                                    </li>
                                  )}
                                </ul>
                              )}
                            </div>
                          </div>
                        </form>

                        <div className="flex mt-12 gap-2 w-full justify-end">
                          <button
                            onClick={() => {
                              setOpenModal(false);
                              setModalType("");
                              setModalData({});
                              setCodigo("");
                              setDescricao("");
                              setImagem("");
                              setCor("");
                              setBuscaItem("");
                              setBuscaCor("");
                              setSelecionado(null);
                              setAberto(false);
                            }}
                            className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                          >
                            Cancelar
                          </button>
                          <button
                            className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                            onClick={() => {
                              codigo ? atualizar() : criar();
                            }}
                          >
                            Salvar
                          </button>
                        </div>
                      </div>
                    ) : modalType === "edit" ? (
                      <div className="flex flex-col box-border p-4 gap-2 w-full">
                        <h1 className="font-Oswald text-center">
                          Editar Grupo
                        </h1>
                        <div className="flex overflow-hidden justify-center items-center flex-col box-border p-4 gap-2 w-full">
                          <div
                            style={{
                              backgroundColor: cor,
                            }}
                            className={`flex max-w-[90%] items-center gap-4 p-2 rounded-lg text-white w-fit`}
                          >
                            <img width={"70px"} src={`${imagem}`} alt="Grupo" />
                            <span className="text-center">{descricao}</span>
                          </div>
                        </div>

                        <form className="flex items-center flex-wrap gap-2 w-full">
                          <div className="flex flex-col gap-2 text-base font-[500]">
                            <label htmlFor="codigo">Código</label>
                            <input
                              name="codigo"
                              type="text"
                              className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              onChange={(e) => setCodigo(e.target.value)}
                              value={codigo}
                              placeholder="Código"
                              disabled
                            />
                          </div>

                          <div className="flex flex-col gap-2 text-base font-[500]">
                            <label htmlFor="descricao">Descrição</label>
                            <input
                              name="descricao"
                              type="text"
                              onChange={(e) => setDescricao(e.target.value)}
                              className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              value={descricao}
                              placeholder="Descrição"
                              required
                            />
                          </div>
                          <div className="font-Roboto flex flex-col gap-2 w-fit">
                            <label
                              className="font-Roboto text-base font-[500] w-fit"
                              htmlFor="select"
                            >
                              Imagem
                            </label>
                            <div className="font-Roboto font-[500] relative">
                              <input
                                autoComplete="off"
                                type="text"
                                name="select"
                                className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Selecione uma opção"
                                value={buscaItem}
                                onChange={(e) => {
                                  setBuscaItem(e.target.value);
                                  // setAberto(!aberto);
                                }}
                                onFocus={() => {
                                  setBuscaItem("");
                                  setAberto(!aberto);
                                }}
                                required
                              />

                              {aberto && (
                                <ul className="font-Roboto text-base font-[500] absolute z-10 w-full bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                                  {itensFiltrados.length > 0 ? (
                                    itensFiltrados.map((option) => (
                                      <li
                                        key={option.value}
                                        className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                        onClick={() => {
                                          setImagem(option.value);
                                          setAberto(false);
                                          setBuscaItem(option.label);
                                        }}
                                      >
                                        <div className="flex items-center gap-4">
                                          <img
                                            src={`${option.value}`}
                                            alt="Grupo"
                                            width={"50px"}
                                          />
                                          <span>{option.label}</span>
                                        </div>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="font-Roboto px-4 py-2 text-gray-500">
                                      Nenhuma opção encontrada
                                    </li>
                                  )}
                                </ul>
                              )}
                            </div>
                          </div>

                          <div className="font-Roboto flex flex-col gap-2 w-fit">
                            <label
                              className="font-Roboto text-base font-[500] w-fit"
                              htmlFor="select"
                            >
                              Cor
                            </label>
                            <div className="font-Roboto font-[500] relative">
                              <input
                                autoComplete="off"
                                type="text"
                                name="select"
                                style={{ backgroundColor: cor }}
                                className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Selecione uma opção"
                                value={buscaCor}
                                onChange={(e) => {
                                  setBuscaCor(e.target.value);
                                  // setAberto2(!aberto2);
                                }}
                                onFocus={() => {
                                  setBuscaCor("");
                                  setAberto2(!aberto2);
                                }}
                                required
                              />

                              {aberto2 && (
                                <ul className="font-Roboto text-base font-[500] absolute z-10 w-full bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                                  {coresFiltradas.length > 0 ? (
                                    coresFiltradas.map((option) => (
                                      <li
                                        key={option.value}
                                        style={{
                                          backgroundColor: option.value,
                                        }}
                                        className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                        onClick={() => {
                                          setCor(option.value);
                                          setAberto2(false);
                                          setBuscaCor(option.label);
                                        }}
                                      >
                                        <span>{option.label}</span>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="font-Roboto px-4 py-2 text-gray-500">
                                      Nenhuma opção encontrada
                                    </li>
                                  )}
                                </ul>
                              )}
                            </div>
                          </div>
                        </form>

                        <div className="flex mt-12 gap-2 w-full justify-end">
                          <button
                            onClick={() => {
                              setOpenModal(false);
                              setModalType("");
                              setModalData({});
                              setCodigo("");
                              setDescricao("");
                              setImagem("");
                              setCor("");
                              setBuscaItem("");
                              setBuscaCor("");
                              setSelecionado(null);
                              setAberto(false);
                            }}
                            className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                          >
                            Cancelar
                          </button>
                          <button
                            className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                            onClick={() => {
                              codigo ? atualizar() : criar();
                            }}
                          >
                            Salvar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col justify-center items-center box-border p-4 gap-8 w-full">
                        <h1 className="font-Oswald text-center">
                          Excluir grupo
                        </h1>
                        <p>
                          Tem certeza que deseja excluir o grupo{" "}
                          <span className="font-bold">
                            {modalData.CODIGO}
                            {" - "}
                            {modalData.DESCRICAO}
                          </span>
                          ?
                        </p>
                        <div className="flex gap-2 justify-end w-full">
                          <button
                            onClick={() => {
                              setOpenModal(false);
                              setModalType("");
                              setModalData({});
                            }}
                            className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                          >
                            Cancelar
                          </button>
                          <button
                            className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                            onClick={() => {
                              excluir(modalData.CODIGO);
                            }}
                          >
                            Excluir
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            <div className="flex flex-col gap-2 w-full lg:w-[80%] justify-center items-center">
              <h1 className="font-Oswald">Grupos</h1>
            </div>

            <div className="flex gap-4 flex-wrap w-full justify-between lg:w-[80%]">
              <div className="flex gap-2 items-center">
                <button
                  onClick={() => {
                    setOpenModal(true);
                    setModalType("create");
                    setDescricao("");
                    setImagem(itemsList[0].value);
                    setCor(cores[0].value);
                    setBuscaItem(itemsList[0].label);
                    setBuscaCor(cores[0].label);
                  }}
                  className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                >
                  <FaPlus />

                  <span>Grupo</span>
                </button>
              </div>

              <input
                type="text"
                placeholder="Pesquisar Grupo..."
                className="p-2 text-base rounded-lg border border-solid border-gray-200"
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
            </div>

            <div className="flex flex-col h-auto gap-2 box-border overflow-visible rounded-lg w-full lg:w-[80%]">
              {filtrados.map((grupo, i) => (
                <div
                  key={grupo.DESCRICAO + i}
                  style={{ backgroundColor: convertAPIColor(grupo.COR) }}
                  className="flex text-white justify-between p-2 lg:p-4 border rounded-lg border-solid border-gray-200"
                >
                  <div className="flex gap-2 items-center">
                    <img
                      className="w-[30px]"
                      src={`/icone/${grupo.IMAGEM}`}
                      alt="Grupo"
                    />
                    <span>
                      {grupo.CODIGO} - {grupo.DESCRICAO}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2 justify-end">
                    {/* TO DO: ADICIONAR TOOLTIPS AOS BOTÕES */}
                    <button
                      onClick={() => {
                        setOpenModal(true);
                        setModalType("edit");
                        setModalData(grupo);
                        setCodigo(grupo.CODIGO);
                        setDescricao(grupo.DESCRICAO);
                        setImagem(`/icone/${grupo.IMAGEM}`);

                        const selectedItem = itemsList.find(
                          (item) => item.value === `/icone/${grupo.IMAGEM}`
                        );

                        const selectedColor = cores.find(
                          (item) => item.value === convertAPIColor(grupo.COR)
                        );

                        if (selectedItem) {
                          setSelecionado(selectedItem);
                          setBuscaItem(selectedItem.label);
                          setAberto(false);
                        }
                        if (selectedColor) {
                          setBuscaCor(selectedColor.label);
                          setAberto2(false);
                          setCor(selectedColor.value);
                        }
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border border-solid border-black p-3 transition cursor-pointer hover:bg-gray-300 font-Roboto"
                    >
                      <FaPencilAlt />
                    </button>
                    <button
                      onClick={() => {
                        setOpenModal(true);
                        setModalType("delete");
                        setModalData(grupo);
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border border-solid border-black p-3 transition cursor-pointer hover:bg-gray-300 font-Roboto"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}
export default Grupos;
